import { render, staticRenderFns } from "./ChargePv.vue?vue&type=template&id=3bb45ff4&scoped=true"
import script from "./ChargePv.vue?vue&type=script&lang=js"
export * from "./ChargePv.vue?vue&type=script&lang=js"
import style0 from "./ChargePv.vue?vue&type=style&index=0&id=3bb45ff4&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb45ff4",
  null
  
)

export default component.exports